<template>
  <div class="add-team">

    <div class="the-form">
      <div class="form-body">
        <!-- form -->

        <q-form @submit="submit">
          <div class="row">
            <div class="col-xs-12 col-sm-6 upload-image">
              <label>Upload Logo</label>
              <div style="position: relative" class="upload-holder">
                <img class="img-perview" v-if="imagePreviewURL" :src="imagePreviewURL" alt=""/>
                <q-file @input="onFileChange" v-model="formData.logo" accept="image/" bg-color="positive" color="teal"
                        filled>
                </q-file>
                <svg xmlns="http://www.w3.org/2000/svg" width="25.1" height="25.1"
                     viewBox="0 0 25.1 25.1">
                  <g id="Icon_feather-upload" data-name="Icon feather-upload"
                     transform="translate(-3.5 -3.5)">
                    <path id="Path_13361" data-name="Path 13361"
                          d="M27.6,22.5v5.133A2.567,2.567,0,0,1,25.033,30.2H7.067A2.567,2.567,0,0,1,4.5,27.633V22.5"
                          transform="translate(0 -2.6)" fill="none" stroke="#7c7c7c"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Path_13362" data-name="Path 13362"
                          d="M23.333,10.917,16.917,4.5,10.5,10.917"
                          transform="translate(-0.867 0)" fill="none" stroke="#7c7c7c"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    <path id="Path_13363" data-name="Path 13363" d="M18,4.5V19.9"
                          transform="translate(-1.95 0)" fill="none" stroke="#7c7c7c"
                          stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </g>
                </svg>

              </div>
            </div>

            <div class="col-xs-12 col-sm-6 forms-info">
              <!-- form inputs -->
              <label>Team Name</label>
              <q-input :rules="formRules.name" v-model="formData.name" bg-color="positive" reactive-rules
                       label-color="secondary" filled label="Enter Team Name"/>
            </div>


            <div class="text-center">
              <div class="the-button">
                <button type="submit" class="wro-button secondaryButtons">
                  <span>Next</span>
                  <spinner v-if="loading"></spinner>
                </button>
                <span class="skew-line-w"></span>
              </div>
            </div>
          </div>
        </q-form>
        <!-- end form -->
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading/loading";
import LoadingBar from "@/components/Loading/LoadingBar";
import Spinner from "@/components/Loading/Spinner";

export default {
  name: 'AddTeam',
  props: ['update'],
  components: {Spinner, LoadingBar, Loading},
  data: () => ({
    formData: {
      name: null,
      logo: null,
      level: null,
    },
    imagePreviewURL: null,
    errors: [],
    loading: false,
    formRules: {
      name: [val => val !== null && val !== '' || 'Please type your team name', val => val && val.length > 2 || 'Full name should be more than 2 letters'],
      logo: [val => val !== null && val !== '' || 'Please insert your team logo'],
      level: [val => val !== null && val !== '' || 'Please insert level'],
    }
  }),
  mounted() {
    if (this.update) {
      this.imagePreviewURL = this.$store.state.userTeam[0].logo
      this.formData.name = this.$store.state.userTeam[0].name;
    }
  },
  methods: {
    submit() {
      this.loading = true;
      let formData = new FormData();
      if (this.formData.logo) formData.append('logo', this.formData.logo);
      formData.append('name', this.formData.name);
      if (!this.update) {
        formData.append('level', 1);

        this.$API.teams.add_team(formData)
            .then(response => {
              this.loading = false;
              this.$q.notify({
                message: 'Team Created Success',
                color: 'green'
              })
              this.$API.teams.get_my_team()
                  .then(response => {
                    this.loading = false;
                    this.$store.commit('get_userTeam', response.data);
                  })
                  .catch(error => {
                    this.loading = false;
                    this.errors = error;
                  });
            })
            .catch(error => {
              this.loading = false;
              this.$q.notify({
                message: error.message,
                color: 'Red'
              })
            });
      } else {
        this.$API.teams.update_team(formData)
            .then(() => {
              this.$q.notify({
                message: 'Your team updated successfully',
                color: 'green'
              });
              this.$emit('updated')
            })
      }
    },
    onFileChange() {
      let file = this.formData.logo;
      if (file) {
        this.imagePreviewURL = URL.createObjectURL(file);
        URL.revokeObjectURL(file);
      } else {
        this.imagePreviewURL = null
      }
    },
  }
}
</script>

<style scoped>
.text-center {
  width: 100%;
  margin: 15px 0;
}

.upload-holder {
  height: 204px;
}

.upload-holder svg {
  position: absolute;
  bottom: 10px;
  right: 5px;
}

.img-perview {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 2;
  border-right: 5px;
  padding: 5px;
}

.upload-image {
  padding-right: 20px !important;
}
</style>